import { render, staticRenderFns } from "./BackCover.vue?vue&type=template&id=767cde48&scoped=true"
import script from "./BackCover.vue?vue&type=script&lang=js"
export * from "./BackCover.vue?vue&type=script&lang=js"
import style0 from "./BackCover.vue?vue&type=style&index=0&id=767cde48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cde48",
  null
  
)

export default component.exports